var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_626_39124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 18.3334C5.39685 18.3334 1.66602 14.6026 1.66602 10.0001C1.66602 5.39758 5.39685 1.66675 9.99935 1.66675C14.6018 1.66675 18.3327 5.39758 18.3327 10.0001C18.3327 14.6026 14.6018 18.3334 9.99935 18.3334ZM8.85102 7.01258C8.80086 6.97912 8.74257 6.95989 8.68235 6.95693C8.62214 6.95398 8.56224 6.96741 8.50905 6.9958C8.45587 7.02419 8.41137 7.06647 8.38031 7.11815C8.34926 7.16982 8.33279 7.22896 8.33268 7.28925V12.7109C8.33279 12.7712 8.34926 12.8303 8.38031 12.882C8.41137 12.9337 8.45587 12.976 8.50905 13.0044C8.56224 13.0328 8.62214 13.0462 8.68235 13.0432C8.74257 13.0403 8.80086 13.021 8.85102 12.9876L12.9168 10.2776C12.9626 10.2472 13.0001 10.2059 13.026 10.1575C13.0519 10.1091 13.0655 10.055 13.0655 10.0001C13.0655 9.94516 13.0519 9.89109 13.026 9.84268C13.0001 9.79426 12.9626 9.75301 12.9168 9.72258L8.85018 7.01258H8.85102Z",
    fill: "#2E2E2E",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_39124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtn);
export default __webpack_public_path__ + "static/media/playBtn.bf7f1353e7ffb3e70bb30ac2a540917a.svg";
export { ForwardRef as ReactComponent };